export function snakeCaseObject(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(snakeCaseObject)
  }
  if (obj !== null && obj.constructor === Object) {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.replace(/([A-Z])/g, '_$1').toLowerCase(),
        snakeCaseObject(value),
      ])
    )
  }
  return obj
}

export function formatDate(date: string | Date): string {
  if (!date) return ''
  return new Date(date).toLocaleDateString()
} 